import { fork, all } from 'redux-saga/effects';

import * as registerPrices from './registerPrices';

export default function* rootSaga() {
  yield all([...Object.values(registerPrices)].map(fork));
}
